import { AnyPeriod, AnyPrice } from "@ct-react/core";
import { AgeCategory, CartOptionType } from "./options";

export type CartPrice = {
  amount: AnyPrice;
  discount?: AnyPrice;
}

export type CartItemPrice = CartPrice & {
  bare: AnyPrice;
  options: { type: CartOptionType, amount: AnyPrice }[];
}

export type DownPayment = {
  rate: number;
  providerCharge?: AnyPrice;
}

export type RentalParticipant = {
  ageCategory: AgeCategory;
  number: number;
}

type CartItem = {
  __typename: string;
  itemId: string;
  title: string;
  description?: string;
  image?: string;
  price: CartItemPrice;
  downPayment: DownPayment;
  expirationDate?: string;
}

export type RentalAccommodationCartItem = CartItem & {
  period: AnyPeriod;
  participants?: RentalParticipant[];
}

export type AnyCartItem = RentalAccommodationCartItem;

export const isRentalAccommodationCartItem = (val: AnyCartItem): val is RentalAccommodationCartItem =>
  val.__typename === "RentalAccommodationCartItem";

export const isCartItemPrice = (val: CartPrice | CartItemPrice): val is CartItemPrice =>
  "bare" in val;
